export * from './nav-dropdown.directive';



// WEBPACK FOOTER //
// /home/ubuntu/JointlyWebService/admin/CollabspaceAdminPortal/src/app/directives/nav-dropdown/index.ts